import type { TokenValidationResult } from "@shared-kernel/application/ports/public/public-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const verifyTokenValidity = createApiThunk<TokenValidationResult, { userId: string; token: string }>(
  "users/verifyTokenValidity",
  async ({ userId, token }: { userId: string; token: string }, { extra: { publicRepository } }) => {
    return publicRepository!.verifyTokenValidity(userId, token);
  },
);
